export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-1.796 1.99L19 21H5l-.204-.01a2 2 0 0 1-1.785-1.786L3 19V5a2 2 0 0 1 2-2h14ZM4.5 19a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V9h-15v10Zm8.25-1h-1.5v-2h1.5v2Zm0-3h-1.5v-2h1.5v2Zm0-3h-1.5v-2h1.5v2ZM5 4.5a.5.5 0 0 0-.5.5v2.5h15V5a.5.5 0 0 0-.5-.5H5Z"/>
</svg>
`;
